import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { getLeadStageHistoryService } from "../../../../Services/CRMAdminServices/CRMTaskListService";

interface StageHistoryRow {
    historyID: number;
    leadID: number;
    fromStage: string | null;
    toStage: string | null;
    fromStageName: string | null;
    toStageName: string | null;
    changedOn: string;          // AEST
    changedById: number | null;
    changedByName: string | null;
    source: string | null;      // crm | created | other
    daysInStage: number | null;
}

const fmt = (iso: string) => {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }).replace(",", "");
};

/**
 * Stage history for one lead - read only. Rows are written by the database itself
 * whenever the lead's Stage changes, so this shows every change from any screen.
 */
const StageHistory = ({ leadID }: any) => {
    const { data, isLoading, isError } = useGetRequestQuery<any>(
        ['getLeadStageHistory', leadID],
        () => getLeadStageHistoryService(leadID),
        { enabled: !!leadID }
    );

    const rows: StageHistoryRow[] = Array.isArray(data?.data) ? data.data : [];

    return (
        <div className="my-3 p-3" style={{ border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', background: '#fff' }}>
            <h3 className="heading-color f-w-900 text-left my-2">Stage History</h3>
            {isLoading ? (
                <div className="text-muted">Loading stage history...</div>
            ) : isError ? (
                <div className="text-danger">Unable to load stage history.</div>
            ) : rows.length === 0 ? (
                <div className="text-muted">No stage changes recorded yet.</div>
            ) : (
                <div style={{ overflowX: 'auto' }}>
                    <table className="table table-sm mb-0" style={{ minWidth: '640px' }}>
                        <thead>
                            <tr style={{ color: '#0000ff', fontWeight: 800, fontSize: '14px' }}>
                                <th>Date / Time</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Changed By</th>
                                <th className="text-end">Days on stage</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r) => (
                                <tr key={r.historyID}>
                                    <td>{fmt(r.changedOn)}</td>
                                    <td>{r.fromStageName || (r.source === 'created' ? '—' : r.fromStage || '')}</td>
                                    <td className="fw-semibold">{r.toStageName || r.toStage || ''}</td>
                                    <td>{r.changedByName || (r.source === 'created' ? 'Lead created' : 'System')}</td>
                                    <td className="text-end">{r.daysInStage != null ? r.daysInStage : ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default StageHistory;
